import React from 'react';
import { useDispatch } from 'react-redux';
import KeydownEnterButton from 'app/components/KeydownEnterButtonComponent';
import KeydownEnterLink from 'app/components/KeydownEnterLinkComponent';
import { closeIcon } from 'app/constants/IconsConstants';
import { hidePopup } from 'app/actions/AppActions';
import { Cinema } from 'app/types/common';
import classNames from 'classnames';
import { setYaReachGoal } from 'app/selectors/Helpers';

const CitiesListSelectComponent = ({selectButton} : {selectButton: Cinema['selectButton']}) => {
	const dispatch = useDispatch();

	const handleClick = ({currentTarget}) => {
		const cinemaLink = currentTarget.dataset.cinemaLink;

		setYaReachGoal('pick-cinema', null, false);
		window.location.replace(cinemaLink);
	};

	return (
		<div className="cities-list-select">
			<div className="cities-list-select__header">
				<h1 className="text text--size-16">{i18n.t('ChooseYourCinema')}</h1>
				<KeydownEnterButton
					className="cities-list-select__hide-btn"
					onClick={() => dispatch(hidePopup())}
				>
					{closeIcon}
				</KeydownEnterButton>
			</div>
			<div className="cities-list-select__list">
				{selectButton.options.map(({value, title, city, address}) => (
					<KeydownEnterLink
						key={value}
						tabIndex={0}
						data-cinema-link={value}
						type="plain"
						onClick={handleClick}
						className={classNames('cities-list-select__city-item', {
							'cities-list-select__city-item--active': value === selectButton.selectedOptionValue
						})}
					>
						<>
							<span>{title}</span>
							<span className="cities-list-select__city-item--region text text--size-14">
								{city}
								<br/>
								{address}
							</span>
						</>
					</KeydownEnterLink>
				))}
			</div>
		</div>
	);
};

export default CitiesListSelectComponent;
